/* eslint-disable @repo/internal/react/require-jsdoc */
import React from 'react';

export const Logo = () => (
	<svg
		width="285"
		height="160"
		viewBox="0 0 285 160"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M130.403 81.8932C127.621 77.7144 126.787 77.4355 126.091 77.4355C125.396 77.4355 124.978 77.7144 123.727 80.2218L106.06 115.601C105.504 116.715 105.365 117.133 105.365 117.69C105.365 118.804 106.338 119.919 108.425 119.919H133.324C134.994 119.919 136.246 118.525 136.941 115.879C137.776 112.536 138.054 109.611 138.054 106.129C138.054 96.3788 133.742 86.9074 130.403 81.8932Z"
			fill="#FCA700"
		/>
		<path
			d="M181.732 115.323L146.4 44.5642C145.704 43.0322 145.009 42.7539 144.174 42.7539C143.479 42.7539 142.645 43.0322 141.81 44.4253C136.802 52.3647 134.577 61.5577 134.577 71.1685C134.577 84.5404 141.392 97.0762 151.408 117.273C152.521 119.501 153.355 119.919 155.303 119.919H179.785C181.593 119.919 182.567 119.223 182.567 117.83C182.567 117.133 182.428 116.716 181.732 115.323Z"
			fill="#1868DB"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M140.046 93.618C141.498 97.0437 143.203 100.668 145.119 104.592L169.38 90.5849L163.991 79.793L140.046 93.618Z"
			fill="var(--color-fill)"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M163.991 79.7931L146.4 44.5647C145.704 43.0322 145.009 42.7539 144.174 42.7539C143.479 42.7539 142.645 43.0322 141.81 44.4253C136.802 52.3647 134.577 61.5577 134.577 71.1685C134.577 78.4432 136.594 85.4699 140.046 93.6176L163.991 79.7931Z"
			fill="#BF63F3"
		/>
		<mask
			id="mask0_50_49411"
			// style="mask-type:luminance"
			maskUnits="userSpaceOnUse"
			x="102"
			y="39"
			width="31"
			height="36"
		>
			<path d="M132.902 39.6475H102.263V74.243H132.902V39.6475Z" fill="white" />
		</mask>
		<g mask="url(#mask0_50_49411)">
			<path
				d="M122.582 63.463C122.892 63.783 123.937 63.2176 123.853 62.7798C123.724 62.1605 123.5 61.5627 123.127 60.8373C122.636 60.0471 122.315 59.9617 122.038 59.3959C121.537 58.4673 120.981 56.7275 120.843 56.3113C120.822 56.247 120.8 56.194 120.758 56.1405C120.502 55.7562 119.391 54.0801 118.655 52.5219C118.079 51.4544 117.716 50.7821 117.524 50.4405C117.076 49.6292 116.638 49.0741 116.115 48.572C115.827 48.3055 114.92 48.7963 114.984 49.1806C115.112 49.8854 115.325 50.5578 115.763 51.3798C115.934 51.6998 116.04 52.5003 116.499 53.4613C116.574 53.6213 116.67 53.7602 116.798 53.8883C117.844 55.0087 118.655 56.7593 118.655 56.7593C118.655 56.7593 120.01 59.2894 120.587 60.3568C121.024 61.1573 121.227 61.5416 121.366 61.787C121.761 62.502 122.145 63.0144 122.593 63.463H122.582Z"
				fill="var(--color-gestural-line)"
			/>
			<path
				d="M115.795 74.1362C116.222 74.2751 116.894 73.293 116.606 72.9514C116.211 72.4606 115.731 72.0229 115.059 71.564C114.258 71.0835 113.927 71.1581 113.426 70.7846C112.551 70.1868 111.259 68.9059 110.95 68.5962C110.907 68.5535 110.854 68.5108 110.8 68.4789C110.395 68.2546 108.645 67.2725 107.268 66.2375C106.265 65.5543 105.635 65.1273 105.315 64.903C104.547 64.3906 103.896 64.0917 103.213 63.8998C102.828 63.7928 102.252 64.6468 102.487 64.9565C102.925 65.5327 103.426 66.024 104.194 66.5574C104.493 66.7606 104.952 67.4222 105.806 68.0627C105.945 68.1692 106.094 68.2443 106.265 68.3081C107.705 68.8205 109.232 70.0052 109.232 70.0052C109.232 70.0052 111.601 71.6278 112.604 72.3109C113.362 72.8233 113.724 73.0687 113.949 73.2184C114.632 73.6773 115.208 73.9551 115.806 74.147L115.795 74.1362Z"
				fill="var(--color-gestural-line)"
			/>
			<path
				d="M131.035 56.1078C131.163 56.5348 132.348 56.5348 132.476 56.1078C132.657 55.4997 132.742 54.8695 132.753 54.048C132.699 53.1189 132.454 52.8951 132.476 52.2649C132.476 51.2083 132.806 49.4149 132.892 48.9879C132.903 48.9242 132.903 48.8598 132.892 48.7961C132.849 48.3372 132.668 46.3303 132.753 44.6116C132.753 43.3949 132.753 42.6367 132.753 42.2421C132.753 41.3135 132.625 40.6195 132.401 39.9364C132.273 39.5629 131.237 39.5629 131.12 39.9364C130.896 40.6195 130.768 41.3135 130.757 42.2421C130.757 42.6048 130.469 43.3522 130.427 44.4197C130.427 44.5905 130.437 44.7613 130.48 44.9424C130.864 46.426 130.757 48.3475 130.757 48.3475C130.757 48.3475 130.757 51.2191 130.757 52.4357C130.757 53.354 130.757 53.7918 130.757 54.0583C130.757 54.8803 130.864 55.51 131.035 56.1186V56.1078Z"
				fill="var(--color-gestural-line)"
			/>
		</g>
	</svg>
);
